import { latestArticles } from "@/mocks/home";
import ArticleCard from "@/components/base/ArticleCard";

export default function ArticleSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
            影视资讯
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            最新文章
          </h2>
          <p className="text-sm text-foreground-500">影视行业深度分析、热门推荐与观影指南</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}